module.exports = __webpack_public_path__ + "img/vital.7b71257c.svg";